@let wallValueValue = wallValue();
<mat-form-field style="width: 100%">
  <mat-label>{{ label() }}</mat-label>

  <input
    matInput
    [formControl]="displayControl"
    [placeholder]="placeholderFormat"
    [required]="required()"
    (blur)="onBlur()"
    (input)="handleDateTimeInput($event)"
  />

  <input
    matInput
    style="display: none"
    [matDatepicker]="dp"
    [value]="wallValueValue"
    (dateChange)="onDatePartChange($event.value)"
  />
  <mat-datepicker #dp />
  <mat-datepicker-toggle matSuffix [for]="dp" />

  <input matInput style="display: none" [appMindMatTimepicker]="tp" [value]="wallValueValue" />
  <mat-timepicker #tp (selected)="onTimePartChange($event.value)" />
  <mat-timepicker-toggle matSuffix [for]="tp" />

  <mat-error>
    {{ displayControl.errors | validatorError }}
  </mat-error>
</mat-form-field>
